<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de Paciente">
            <rkm-layout-content>
                <List :item="item" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/transporte-paciente/agendar/List'

export default {
    components: { List },
    methods: {
        redirectToMainTransporteAgendar(paciente) {
            this.$router.push({ name: 'transporte-paciente-agendar-create', params: { id: paciente.id } })
        },
    },
    props: {
        item: { type: Object, default: null }
    },
}
</script>